import { _request,APIBaseResponse, APIMethod } from '../index';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const USER_GROUP_PATH_PREFIX = 'usergrouprolememberships';

type APIUserGroupRoleListParams = RequestParamsBase & {
    tenantId: string;
    roleId: string;
};

type APIUserGroupRoleListResponse = APIBaseResponse<Array<{
    roleId: string;
    roleName: string;
    userGroupId: string;
    userGroupName: string;
    userGroupDescription: string;
}>>;

type APIRoleUserGroupsPostParams = {
    tenantId: string;
    roleId: string;
    userGroupId: string;
}

type APIRoleUserGroupsPostResponse = APIBaseResponse;

type APIUserGroupRoleMembershipDeleteParams = {
    tenantId: string;
    roleId: string;
    userGroupId: string;
}

type APIUsergroupRoleMembershipDeleteResponse = APIBaseResponse;

export const APIUserGroupRoleGetList: APIMethod<APIUserGroupRoleListParams, APIUserGroupRoleListResponse> = params => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUP_PATH_PREFIX}?roleId=${params.roleId}`, undefined, params.signal)
);

export const APIUserGroupRolePost: APIMethod<APIRoleUserGroupsPostParams, APIRoleUserGroupsPostResponse> = params => (
    _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUP_PATH_PREFIX}`, {
        roleId: params.roleId,
        userGroupId: params.userGroupId,
    })
);

export const APIUserGroupRoleMembershipDelete: APIMethod<APIUserGroupRoleMembershipDeleteParams, APIUsergroupRoleMembershipDeleteResponse> = params => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_GROUP_PATH_PREFIX}?roleId=${params.roleId}&userGroupId=${params.userGroupId}`)
);
